import React from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import BaseText from '../BaseText';
import Icon from '../Icon';
import { CommonStyles, CommonProperties, Color, defaultFontSize } from '../../styles';
import { scale } from '../../utils/scale.utils';

const HeaderTitle = ({ title, titleStyle, subtitle, onPress }) => {
  return (
    <View style={CommonStyles.centerAlignment}>
      <TouchableOpacity style={styles.row} onPress={onPress}>
        <BaseText style={[styles.header, titleStyle]}>{title}</BaseText>
        {onPress && <Icon name="chevronDown" style={styles.iconHeader} />}
      </TouchableOpacity>
      <BaseText style={styles.subtitle}>{subtitle}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    ...CommonProperties.centerAlignment,
  },
  iconHeader: {
    color: Color.primary,
    ...CommonProperties.ml2,
  },
  header: {
    fontSize: scale(defaultFontSize.h3, 0.2),
    color: Color.primary,
  },
  subtitle: {
    fontSize: scale(defaultFontSize.body, 0.2),
  },
});

export default HeaderTitle;
